// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__5V4sM","loader":"Loader_loader__M5VKe","load6":"Loader_load6__IGZ2+","round":"Loader_round__8JZUm"};